import {firestore} from "../../firebase/firebase";
import moment from "moment";
import {CardElement} from "@stripe/react-stripe-js";

export default (state, props) => {
	return new Promise(async (resolve, reject) => {
		let credit = 0;
		if (props.auth.agent || !props.auth.type.endsWith("Admin")) {
			const agentId = props.auth.agent || props.auth.uid;
			const doc = await firestore.doc("agents/" + agentId).get();
			credit = doc.exists && doc.data() ? doc.data().credit || 0 : 0;
		}

		// Skip validations for Admin (testing)
		if (props.auth.type.endsWith("Admin")) {
			return resolve();
		}

		if (!state.client) {
			return reject({
				title: "Client Error",
				content: "Please select a client",
			});
		}
		if (!state.coverage) {
			return reject({
				title: "Coverage Error",
				content: "Please select a coverage",
			});
		}
		if (!state.vin) {
			return reject({
				title: "Vin Error",
				content: "Please select a VIN",
			});
		}
		if (!state.year) {
			return reject({
				title: "Year Error",
				content: "Please select a year",
			});
		}
		if (!state.make) {
			return reject({
				title: "Make Error",
				content: "Please select a make",
			});
		}
		if (!state.model) {
			return reject({
				title: "Model Error",
				content: "Please select a model",
			});
		}
		if (!state.from) {
			return reject({
				title: "Date Range Error",
				content: "Please select a starting date",
			});
		}
		if (!state.to) {
			return reject({
				title: "Date Range Error",
				content: "Please select an ending date",
			});
		}
		if (!state.image || (state.extra && !state.imageExtra)) {
			return reject({
				title: "Missing Files",
				content: "Please the vehicle's title",
			});
		}

		const insuranceStart = moment(state.from["toDate"]());
		if (!insuranceStart.isAfter()) {
			return reject({
				title: "Date Range Error",
				content: "This date is in the past. Please double check the time.",
			});
		}

		else{
			resolve();
		}
	});
}